const KEY = "rutaforge.tracks.v1";
const CURRENT_KEY = "rutaforge.current.v1";

export function loadTracks() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export function saveTracks(tracks) {
    localStorage.setItem(KEY, JSON.stringify(tracks));
}

export function loadCurrent() {
    try {
        const raw = localStorage.getItem(CURRENT_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function saveCurrent(track) {
    if (!track) {
        localStorage.removeItem(CURRENT_KEY);
        return;
    }
    localStorage.setItem(CURRENT_KEY, JSON.stringify(track));
}
